import { TOTAAL_KORTING_AB_TEST } from 'shared/experiments/consts'
import {
  CART_CHECKOUT_BUTTON_CLICK,
  CART_REMOVE_PRODUCT_CLICK,
  CART_VOUCHER_SUBMIT_CLICK,
} from 'shared/experiments/consts/events'
import { event as e } from 'shared/experiments/utils/event'
import {
  activateExperiment,
  getExperimentOnClient,
} from 'shared/experiments/utils/experiments'
import trackEvent from 'shared/experiments/utils/trackOptimizelyEvent'
import store, { subscribe } from 'shared/store'
import {
  ADD_VOUCHER_SUCCESS,
  DELETE_CART_ITEM_SUCCESS,
  DELETE_VOUCHER_SUCCESS,
  UPDATE_CART_SUCCESS,
} from 'shared/store/ducks/cart/types.consts'
import type { CartState } from 'types/redux'

const VOUCHER_REMOVED_EVENT = e`Cart - click on remove voucher button`

const getLinePercentCouponsOnCart = (cart: CartState) =>
  cart.data.sellerGroups.flatMap(group =>
    group.discounts.filter(discount => discount.promotionType === 'linePercent')
  )

export default () => {
  const experiment = getExperimentOnClient(TOTAAL_KORTING_AB_TEST)

  if (!experiment.isEnabled) {
    return
  }

  subscribe.after(UPDATE_CART_SUCCESS, () => {
    if (getLinePercentCouponsOnCart(store.getState().cart)) {
      void activateExperiment(TOTAAL_KORTING_AB_TEST)
    }
  })

  const toCheckoutButton = document.getElementById('ToCheckout')
  toCheckoutButton?.addEventListener('click', () => {
    if (getLinePercentCouponsOnCart(store.getState().cart).length > 0) {
      trackEvent(CART_CHECKOUT_BUTTON_CLICK)
    }
  })

  subscribe.after(DELETE_CART_ITEM_SUCCESS, () => {
    trackEvent(CART_REMOVE_PRODUCT_CLICK)
  })

  subscribe.after(ADD_VOUCHER_SUCCESS, () => {
    trackEvent(CART_VOUCHER_SUBMIT_CLICK)
  })

  subscribe.after(DELETE_VOUCHER_SUCCESS, () => {
    trackEvent(VOUCHER_REMOVED_EVENT)
  })
}
